import { render, staticRenderFns } from "./AdminProfilePage.vue?vue&type=template&id=5ffc4bb8&"
import script from "./AdminProfilePage.vue?vue&type=script&lang=ts&"
export * from "./AdminProfilePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports